// Event.js

import React, { Component } from 'react';
//import { withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import axios from 'axios';

class Event extends Component {
  state = {
    event: []
  }

  componentDidMount() {
    axios.get("https://beiseker.bookice.ca/api/v0/events/"+this.props.match.params.id)
      .then(res => {
        const event = res.data;
        this.setState({ event });
      })
  }

  handleClick(e) {
    e.preventDefault();
    if (this.props.history.length == 1) {
      this.props.history.push(`/`);
    } else {
      this.props.history.goBack();
    }
  }

  render() {
    return (
        <div class="eventView">
          <h2>Event</h2>
          <p>Title: { this.state.event.title }</p>
          <p>Start:  <Moment format="YYYY/MM/DD hh:mm a" date={this.state.event.start} /></p>
          <p>End: <Moment format="YYYY/MM/DD hh:mm a" date={this.state.event.end} /></p>
          <p>Duration: <Moment diff={this.state.event.start} unit="hours" decimal>{this.state.event.end}</Moment> hour(s)</p>
          <p>Type: { this.state.event.type }</p>

          <h3>Dressing Rooms</h3>
          <p>Home: { this.state.event.home_room }</p>
          <p>Away: { this.state.event.away_room }</p>
          <div>
          <button className='btn btn-info' onClick={this.handleClick.bind(this)}>Back</button>
          </div>
        </div>
    );
  }
}

export default Event;


// WEBPACK FOOTER //
// ./src/components/Event.js